import script from "./AdminPaymentFailResultView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPaymentFailResultView.vue?vue&type=script&setup=true&lang=js"

import "./AdminPaymentFailResultView.vue?vue&type=style&index=0&id=3aaa8748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aaa8748"]])

export default __exports__